/**
 * Relay global-id helpers, vendored from the host apps so the package decodes
 * ids without importing from either one. Both apps' copies are identical; keep
 * this in sync with `common/helpers/globalId` if that ever changes.
 */

/**
 * Takes a global GraphQL ID and returns the database ID
 *
 * @param globalId
 */
export function toDbId(globalId: string): number {
  return parseInt(atob(globalId).split(":")[1], 10);
}

/**
 * Takes an object type and database ID and returns a global ID
 *
 * @param objectType
 * @param dbId
 */
export function toGlobalId(objectType: string, dbId: number | string): string {
  return btoa([encodeURIComponent(objectType), dbId].join(":"));
}
